"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.company.list': '公司',
    'route.company.create': '添加公司',
    'route.company.edit': '编辑公司',
};
